module.exports = __webpack_public_path__ + "img/fas-caret-right.bcdb3c5c.svg";